// start:ng42.barrel
export * from './shared.module';
export * from './spinner.component';
export * from './breadcrumb';
export * from './layouts';
export * from './layouts/blank';
export * from './layouts/full';
// end:ng42.barrel
